import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NAVLEFT = _resolveComponent("NAVLEFT")
  const _component_NAVTOP = _resolveComponent("NAVTOP")

  return (_openBlock(), _createBlock("div", {
    class: {navCollapsed:_ctx.state.isSidebarNavCollapse}
  }, [
    _createVNode(_component_NAVLEFT, { class: "sidebar theme-bg" }),
    _createVNode(_component_NAVTOP)
  ], 2))
}